export const Logo = ({ size = 40, withText = true, variant = "dark" }) => {
  const textColor = variant === "light" ? "text-white" : "text-slate-900";
  const subColor = variant === "light" ? "text-amber-200" : "text-[#C5A059]";
  return (
    <div className="flex items-center gap-3" data-testid="logo-oscop-ge" suppressHydrationWarning>
      <img
        src="/brand/logo-oscop-ge.png"
        alt="O'SCOP GE — Groupement d'Employeurs Coopératif"
        style={{ width: size, height: size, objectFit: "contain" }}
        className="shrink-0"
      />
      {withText && (
        <div className="leading-tight">
          <div className={`font-bold text-base tracking-tight ${textColor}`} style={{ fontFamily: "Outfit, sans-serif" }}>
            O&apos;SCOP <span className={subColor}>GE</span>
          </div>
          <div className="text-[9px] uppercase tracking-[0.18em] text-slate-400">Mutualiser les talents, réussir ensemble</div>
        </div>
      )}
    </div>
  );
};

export default Logo;
